/* `DateField` — a date written in the app's language over the browser's own picker. */

.root {
  position: relative;
  display: inline-flex;
  align-items: center;
  min-width: 0;
}

.button {
  position: relative;
  z-index: 1;
  padding: var(--space-0);
  font: inherit;
  color: inherit;
  white-space: nowrap;
  cursor: pointer;
  background: transparent;
  border: 0;
  font-variant-numeric: tabular-nums;
}

.button:focus-visible {
  border-radius: var(--r-chip);
  outline: var(--border-focus) solid var(--focus);
  outline-offset: var(--space-2px);
}

/* Under the button, the size of the field, so the picker opens where the trainer looked. Invisible
 * and inert to the pointer; the button is the only target. */
.native {
  position: absolute;
  inset: var(--space-0);
  width: 100%;
  height: 100%;
  padding: var(--space-0);
  pointer-events: none;
  opacity: 0;
  border: 0;
}
